var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import UserPropertyEndpoints from "src/shared/api/user-property/UserPropertyEndpoints";
import { getFavoriteProgramsFromResponse, serializeFavoriteIntoUserProperty, } from "./presets-configurations";
const fetchUserProperties = (userId) => {
    return new Promise((resolve, reject) => {
        UserPropertyEndpoints.getProperties(userId)
            .then((userPropertyResponse) => {
            resolve(userPropertyResponse);
        })
            .fail(() => {
            reject();
        });
    });
};
const updateExistingUserProperty = (update) => {
    return new Promise((resolve, reject) => {
        const request = serializeFavoriteIntoUserProperty(update);
        UserPropertyEndpoints.updateProperty(update.userId, request)
            .then(() => {
            resolve();
        })
            .fail(() => {
            reject();
        });
    });
};
const createNewUserProperty = (update) => {
    return new Promise((resolve, reject) => {
        const request = serializeFavoriteIntoUserProperty(update);
        UserPropertyEndpoints.createProperty(update.userId, request)
            .then(() => {
            resolve();
        })
            .fail(() => {
            reject();
        });
    });
};
const saveFavoritesConfigurations = (update) => __awaiter(void 0, void 0, void 0, function* () {
    const { userId, clientId } = update;
    const userPropertyResponse = yield fetchUserProperties(userId);
    const clientProperty = getFavoriteProgramsFromResponse(userPropertyResponse, clientId);
    if (clientProperty) {
        yield updateExistingUserProperty(update);
    }
    else {
        yield createNewUserProperty(update);
    }
});
export default saveFavoritesConfigurations;
